import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconPanoramaView: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconPanoramaView"><Path d="M22.5 19.5V4.5C15.2572 6.9564 8.74278 6.9564 1.5 4.5V19.5C8.70327 17.018 15.2967 17.018 22.5 19.5Z" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconPanoramaView;
